import { postForm } from '@/shared/api/client';
import { submitForm } from '@/shared/api/submit';
import { getListRows } from '@/shared/lib/pagination';
import type { ListResponse } from '@/shared/ui/list/types';

export const saveOrderCheckbox = (orderId: number, checked: boolean) =>
  submitForm('/part/checkbox-save/', { order_id: orderId, checkbox: checked });

export interface PartService {
  id: number;
  shipment_address_id?: number;
  is_legal_entity?: number;
  is_admin?: number | boolean;
  part_phone?: string | number;
  part_contact?: string;
}

/** Updates only the activity status; the other fields are echoed back as legacy does. */
export const savePartServiceStatus = (service: PartService, status: boolean) =>
  submitForm('/part/service/save/', {
    service_id: service.id,
    status,
    shipment_address_id: service.shipment_address_id,
    is_legal_entity: service.is_legal_entity,
    is_admin: Boolean(service.is_admin),
    part_phone: service.part_phone,
    part_contact: service.part_contact,
  });

// ---- order / cart detail ---------------------------------------------------

export interface PartOrder extends Record<string, unknown> {
  id: number;
  create_time?: number;
  status_name?: string;
  client_order_sum?: number | string;
  supplier_order_sum?: number | string;
  customer_phone?: string;
  customer_name?: string;
  delivery_address?: string;
  bonus_pay?: number | string;
  user_id?: number;
}

export interface OrderPart extends Record<string, unknown> {
  id: number;
  article_name?: string;
  description?: string;
  brand_name?: string;
  quantity?: number;
  distributor_price?: number | string;
  distributor_name?: string;
  distributor_order_id?: string | number;
  customer_price?: number | string;
  status?: string;
}

const fetchOrderRows = async <T extends Record<string, unknown>>(url: string, orderId: number) =>
  getListRows<T>(await postForm<ListResponse>(url, { order_id: orderId }), ['data']);

export const fetchPartOrder = (orderId: number) => fetchOrderRows<PartOrder>('/part/order/list/', orderId);
export const fetchOrderParts = (orderId: number) => fetchOrderRows<OrderPart>('/part/list/', orderId);

export interface CartUser {
  user_role?: string;
  user_id?: number | string;
  register_date?: number;
  user?: string;
  email?: string;
  phone?: string;
  balance?: number | string;
  bonus_balance?: number | string;
}

export interface CartInfo {
  create_time?: number;
  update_time?: number;
  total_orders?: number | string;
}

export interface CartItem extends Record<string, unknown> {
  article_name?: string;
  brand_name?: string;
  customer_price?: number | string;
  description?: string;
  distributor_price?: number | string;
  quantity?: number;
}

export interface CartDetail {
  items?: CartItem[];
  cart?: CartInfo;
  user?: CartUser;
}

export const fetchCartDetail = (cartId: number) =>
  postForm<CartDetail>('/part/cart/cart-info/', { cart_id: cartId });
